import { Suspense, lazy } from "react";
import Loader from "../customs/loader/main";
import Layout from "../components/dashboard/main";

const Main = lazy(() => import("../components/statementOfResult/main"));

const StatementOfResult = () => {
  return (
    <Layout pageHeading="Statement of Result">
      <Suspense fallback={<Loader />}>
        <Main />
      </Suspense>
    </Layout>
  );
};

export default StatementOfResult;
